import { validateEndDate } from "src/main/Billing/Items/validators"
import * as yup from "yup"

import { SPACE_TYPES } from "./constants"

export const schema = yup
  .object()
  .shape({
    first_day: yup.date().required("First day is required."),
    last_day: yup
      .date()
      .required("Last day is required.")
      .test(
        "testing valid last day",
        "Last day is invalid",
        (lastDay, context) => {
          const invalid = validateEndDate({
            end: lastDay,
            start: context.parent?.first_day,
          })
          if (invalid) {
            return context.createError({
              message: "Must be the same as or later than first day.",
              path: "lastDay",
            })
          }
          return true
        }
      ),
    // contact_id and contact_boat_id are validated by the picker (its own
    // Controller rules + resolveSelection guards). The picker manages two
    // states the yup schema can't see — inline-create panels where ids are
    // still empty by design — so leaving these required here would block
    // submit from ever calling onSubmit / resolveSelection.
    contact_boat_id: yup.string(),
    contact_id: yup.string(),
    special_request: yup.string(),
    space_type: yup
      .string()
      .oneOf(SPACE_TYPES.map((spaceType) => spaceType.value)),
  })
  .required()
